import { Form, Formik, FormikValues } from "formik";
import { Button, Card, Input } from "../../custom";
import styles from "./style.module.scss";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { loginUser } from "../../utils/auth_request";
import { validator } from "../../utils/validator";
import { routes } from "../../routes";
import { useSetAtom } from "jotai";
import { pageIndexAtom, userAtom } from "../../utils/store";

const validationSchema = Yup.object().shape({
  email: validator.email,
  password: validator.password,
});

const Login = () => {
  const setUser = useSetAtom(userAtom);
  const setPageIndex = useSetAtom(pageIndexAtom);

  const { notification } = App.useApp();
  const navigate = useNavigate();

  const loginMutation = useMutation({
    mutationKey: ["login"],
    mutationFn: loginUser,
  });

  const handleLogin = async (
    values: FormikValues,
    // resetForm: () => void
  ) => {
    const payload: LoginPayload = {
      email: values.email,
      password: values.password,
    };

    try {
      await loginMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });

          setUser({
            token: data?.data?.token,
            isNewUser: data?.data?.isNewUser,
            applicantId: data?.data?.applicantId,
            applicationBatchId: data?.data?.applicationBatchId,
            programType: data?.data?.programTypeName,
            firstName: data?.data?.fName,
            lastName: data?.data?.lName,
            email: data?.data?.email,
            phoneNo: data?.data?.phoneNo,
            applicationName: data?.data?.applicationName,
            sessionId: data?.data?.sessionId,
            programTypeId: data?.data?.programTypeId!,
            amount: data?.data?.amount,
            earlyApplicationAmount: data?.data?.earlyApplicationAmount || 0,
            lateApplicationAmount: data?.data?.lateApplicationAmount || 0,
            applicationStartDate: data?.data?.applicationStartDate,
            applicationEndDate: data?.data?.applicationEndDate,
            lateApplicationStartDate: data?.data?.lateApplicationStartDate,
            lateApplicationEndDate: data?.data?.lateApplicationEndDate,
            isPaymentSubmitted: data?.data?.isPaymentSubmitted,
            programName: data?.data?.programName,
            modeOfStudyName: data?.data?.modeOfStudyName,
            isPersonalInfoSubmitted: data?.data?.isPersonalInfoSubmitted,
            isqualificationSubmitted: data?.data?.isqualificationSubmitted,
            isworkhistorySubmitted: data?.data?.isworkhistorySubmitted,
            iInstitutionSubmitted: data?.data?.iInstitutionSubmitted,
            institutionShortName: data?.data?.institutionShortName,
            applicationNumber: data?.data?.applicationNumber,
            acceptanceFee: data?.data?.acceptanceFee,
          });

          setTimeout(() => {
            if (
              data?.data?.isNewUser &&
              data?.data?.isPaymentSubmitted === false
            ) {
              setPageIndex(1);
              navigate(routes.onboarding);
            } else {
              navigate(routes.dashboard.dashboard);
            }
          }, 1000);
          // resetForm();
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message,
      });
    }
  };

  const handleBackNavigate = () => {
    navigate(routes.auth.landing);
  };

  return (
    <section className={styles.container}>
      <div>
        <Card>
          <div className={styles.cardChild}>
            <div>
              <h3>Welcome to our portal</h3>
              <p>Login as a Returning Applicant</p>
            </div>

            <div>
              <div>
                <Formik
                  initialValues={{
                    email: "",
                    password: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={(values) => {
                    handleLogin(values);
                  }}
                >
                  {() => {
                    return (
                      <Form>
                        <div className={styles.formStyle}>
                          <Input name="email" label="Email:" isRow />
                          <Input
                            name="password"
                            type="password"
                            label="Password:"
                            isRow
                          />
                        </div>

                        <div>
                          <div className={styles.buttonGroup}>
                            <Button
                              text="Back to home"
                              type="button"
                              onClick={handleBackNavigate}
                              className={styles.backButton}
                            />
                            <Button
                              text="LOG-IN"
                              type="submit"
                              disabled={loginMutation?.isPending}
                              isLoading={loginMutation?.isPending}
                              className={styles.loginButton}
                            />
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            <Link to={routes.auth.forgotPassword}>
              <p>Forgot Password?</p>
            </Link>
          </div>
        </Card>
      </div>
    </section>
  );
};

export default Login;
